import React, { useState, useEffect, useContext } from "react";
import { HeaderConfig } from "./config";
import CustomTable from "../../../../core/custom-table";
import {
  HTTP_METHODS,
  invokeApi,
  plainApi,
} from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CustomButtonComponent from "../../../../core/custom-button";
import DeleteModal from "../../../../components/delete-modal";
import CreateFailedEngineAnalysis from "./create-failed-engine";
import FailedEngineFilter from "./failed-engine-filter";
import AttachmentModal from "../../../../components/attachment-modal";
import AppContext from "../../../../utils/context";
import { checkForUserLimit, PAGE_LIMIT } from "../../../../utils";
import { USER_LIMITS } from "../../../../utils/constants";

const FailedEngineAnalysis = () => {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [editData, setEditData] = useState({});
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });
  const [mainFilters, setMainFilters] = useState({});
  const [filters, setFilters] = useState({
    page: 1,
    limit: PAGE_LIMIT,
    sortBy: "-createdAt",
  });
  const [downloadAttachment, setDownloadAttachment] = useState({
    isOpen: false,
    data: [],
  });
  const { userDetails = {} } = useContext(AppContext);

  const ClickHandler = (type, data) => {
    switch (type) {
      case "DOWNLOAD":
        setDownloadAttachment({
          isOpen: true,
          data: [...data.attachments],
        });
        break;
      case "EDIT":
        setIsCreate(true);
        setEditData(data);
        break;
      case "DELETE":
        setIsDelete({ isOpen: true, data: data });
        break;
      default:
        break;
    }
  };
  const deleteHandler = () => {
    invokeApi(
      HTTP_METHODS.DELETE,
      `${HOSTNAME}${REST_URLS.FAILED_ENGINE_ANALYSIS}/${isDelete?.data?.id}`
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          toast.success("Deleted Successfully");
          setIsDelete({ isOpen: false, data: {} });
          loadData(filters);
        }
      })
      .catch((err) => console.error(err));
  };
  const loadData = (filters) => {
    setIsLoading(true);
    plainApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.FAILED_ENGINE_ANALYSIS}`,
      null,
      filters
    )
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          setData(res);
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  const downloadReports = () => {
    invokeApi(
      HTTP_METHODS.GET,
      `${HOSTNAME}${REST_URLS.FAILED_ENGINE_ANALYSIS}`,
      null,
      { download: "TRUE" },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `failed engines.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err, "here"));
  };
  useEffect(() => {
    if (data?.totalPages !== 0 && data?.totalPages < data?.page) {
      setFilters({ ...filters, page: 1 });
      loadData({
        ...filters,
        ...mainFilters,
        page: 1,
      });
    }
  }, [data]);
  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        {isCreate && (
          <IconButton
            onClick={() => {
              setIsCreate(false);
              setEditData({});
            }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <div>
          <p className="tab-name">Analysis</p>
          <p className="section-name">Failed engine analysis report</p>
        </div>
      </div>

      {isCreate ? (
        <CreateFailedEngineAnalysis
          loadData={loadData}
          setIsCreate={setIsCreate}
          editData={editData}
        />
      ) : (
        <div>
          <div className="create-con">
            <p className="primary-text">Failed engine analysis report</p>
            <div>
              <CustomButtonComponent
                variant="contained"
                color="success"
                sx={{ mr: 2 }}
                onClick={downloadReports}
              >
                Download
              </CustomButtonComponent>
              {checkForUserLimit(
                USER_LIMITS.QUALITY_CREATOR,
                userDetails.limits
              ) && (
                <CustomButtonComponent
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setIsCreate(true);
                    setEditData({});
                  }}
                >
                  Create Failed Engine
                </CustomButtonComponent>
              )}
            </div>
          </div>
          <div className="si-hide-mobile">
            <CustomTable
              header={HeaderConfig(userDetails)}
              data={data.results || []}
              pageCount={data.totalPages}
              filters={filters}
              onClick={ClickHandler}
              onChange={(page) => {
                setFilters({
                  ...filters,
                  page,
                });
                loadData({
                  ...filters,
                  ...mainFilters,
                  page,
                });
              }}
              filterCom={
                <FailedEngineFilter
                  loadData={loadData}
                  setMainFilters={setMainFilters}
                  filter={filters}
                />
              }
              isLoading={isLoading}
            />
          </div>
        </div>
      )}
      {isDelete?.isOpen && (
        <DeleteModal
          deleteHandler={deleteHandler}
          onClose={() => {
            setIsDelete({ isOpen: false, data: {} });
          }}
        />
      )}
      {downloadAttachment?.isOpen && (
        <AttachmentModal
          attachments={downloadAttachment?.data}
          onClose={() => setDownloadAttachment({ isOpen: false, data: [] })}
        />
      )}
    </div>
  );
};
export default FailedEngineAnalysis;
